// oxlint-disable cf-web/no-barrel-file -- This barrel is intentional. It surfaces
// generated protobuf enums to consumers in other apps/packages, and it exists for
// two reasons:
//
//  1. Single nominal type across apps. These enums are passed into shared hooks
//     that live here (e.g. usePriceQuery(action: PricingAction) in ./hooks/use-price).
//     protobuf-es emits them as TypeScript `enum`s, which are NOMINAL — an enum
//     generated in another app's gen/ is a different, non-assignable type even if
//     its members are identical. So every consumer (studio, lumo, studio-components)
//     MUST import the one enum generated in this package, or the shared hook's
//     parameter types won't line up. Re-generating per app is not an option.
//  2. Don't reach into another package's gen/ folder. Importing the deep gen path
//     directly across a package boundary couples callers to a codegen
//     implementation detail (the path changes with codegen) and is harder to read.
//     This barrel gives them a stable name (@repo/studio-hooks-coins/enums) instead.
//
// Add other generated enums here as consumers need them.
export { PricingAction } from '@repo/studio-hooks-coins/gen/service/creativefabrica/coins/v2/types_pb'
